export const SLACK_BOT = {
  ACCESS_DENIED: 'Access Denied By User.',
  SEND_PERK_NOTIFICATION:
    'Click here to send a notification about this perk to your slack organisation.',
  NO_CHANNELS_FOUND:
    'No channels found, please create some public channels in your workspace or add perkforce slack app to some private channels to continue.',
  INVALID_CHANNEL: 'Invalid channel, please try again.',
  INVALID_WORKSPACE_DATA: 'Invalid workspace data, please try again.',
  SELECT_CHANNEL:
    'Please select channel to continue to send a notification to slack.',
  ERROR_OCCURRED:
    'Error ocurred while opening slack app to complete the integration process.',
  ENABLE_INTEGRATION: 'Please enable slack integration to use this feature.',
} as const;

export const SLACK = {
  NOTIFICATION_SENT: 'Notification sent successfully.',
  CONNECTED:
    "Congrats! You're now connected to Slack.\nNow each perk has a feature where you can notify your Slack channels about it. 🚀",
  DISCONNECTED:
    "You're now disconnected from Slack.\nReconnect anytime to access its amazing features again.",
  ENABLED:
    'Slack is enabled again!\nAll its amazing features are ready for you to enjoy.',
  DISABLED:
    "Slack is disabled.\nYou're still connected, so turning it back on is easy whenever you're ready!",
} as const;
